import React, {Fragment, useContext} from 'react';
import {PayTableContext} from '@gongxigames/framework/slot/modules/oddsUpfront/OddsUpfrontReactView';
import {PayTableRow} from '@gongxigames/framework/slot/modules/oddsUpfront/components/PayTableRow';

type PayTableProps = {
    isMobile: boolean;
    numberPerRow: number;
    insertion?: {
        children: JSX.Element;
        index: number;
    };
};

export function PayTable({isMobile, numberPerRow, insertion}: PayTableProps): JSX.Element {
    const rows: JSX.Element[] = [];
    const symbols: [string, string][] = Object.entries(useContext(PayTableContext).symbols)
        .map(([symbolId, {symbolSpriteSrc}]) => [symbolId, symbolSpriteSrc]);
    const index = insertion?.index ?? 0;
    let currentIndex = 0;

    while(symbols.length) {
        let perRow = numberPerRow;
        let renderInsertion = false;

        if (index !== 0 && currentIndex + numberPerRow > index && currentIndex <= index) {
            renderInsertion = true;
            perRow = index - currentIndex;
        }

        const row = symbols.splice(0, perRow);

        currentIndex += numberPerRow;

        rows.push(
            <Fragment key={rows.length}>
                <PayTableRow symbols={row} isMobile={isMobile}/>
                {renderInsertion ? insertion?.children : <></>}
            </Fragment>
        );
    }

    return (
        <Fragment>
            {rows}
        </Fragment>
    );
}
